module.exports = __webpack_public_path__ + "static/media/success.5da86e86.svg";